import React, {useContext} from 'react';
import PropTypes from 'prop-types';
import Icon from "../../Atoms/Icon";
import {FloatContainerContext} from "../../../contexts/contexts";

const NoveltyTypeItem = props => {
  const {icon, type, caption, isActive, isSelected} = props
  const {setActive} = useContext(FloatContainerContext)
  return (
    <div
      onClick={() => setActive(false)}
      className={`Novelty-type-item hover-change normal-radius s-px-8px s-py-4px cursor-pointer ${isActive && 'is-active'}`}
    >
      <header className="header s-color-title s-cross-center nowrap">
        <Icon svg={icon}
          className="s-mr-4px"/>
        <p className="s-mb-0 s-mr-8px">{type}</p>
        {isSelected && (
          <Icon svg="down"
            size="12px"/>
        )}
      </header>
      <p className="s-mb-0 s-color-light-text smaller">{caption}</p>
    </div>
  );
};

NoveltyTypeItem.propTypes = {
  icon: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  caption: PropTypes.string.isRequired,
  isActive: PropTypes.bool,
  isSelected: PropTypes.bool,
};

NoveltyTypeItem.defaultProps = {
  isActive: false,
  isSelected: false,
}

export default NoveltyTypeItem;
